"use strict";

exports.__esModule = true;
exports.ReportingPeriodContext = void 0;
var _Utils = require("../../../../Utils");
/**
 * Provides a reporting period to consumers.
 * @component
 */
var ReportingPeriodContext = exports.ReportingPeriodContext = (0, _Utils.createEnhancedContext)({
  propName: "reportingPeriod"
});